import { useState, useRef, useEffect } from "react";
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import "./App.css";

import { AudioProvider } from "./Services/AudioProvider";
import AccessControlRoute from "./utils/AccessControlRoute";
import Dashboard from "./pages/Dash/Dashboard";
import LoginPage from "./pages/Users/LoginPage";
import Unauthorized from "./pages/Errors/Unauthorized";
import Page404 from "./pages/Errors/Page404";
import UsersAll from "./pages/Users/UsersAll";
import UsersCreate from "./pages/Users/UsersCreate";
import ChangePassword from "./pages/Users/ChangePassword";
import ForgotPassword from "./pages/Users/ForgotPassword";
import Tasks from "./pages/Tasks/Tasks";
import Playlists from "./pages/Playlists/Playlists";
import PlaylistsSettings from "./pages/Playlists/PlaylistsSettings";
import CreateTask from "./pages/Tasks/CreateTask";
import EditTask from "./pages/Tasks/EditTask";
import WhitelistList from "./pages/Whitelists/WhitelistList";
import WhitelistCreate from "./pages/Whitelists/WhitelistCreate";
import WhitelistEdit from "./pages/Whitelists/WhitelistEdit";
import Sidebar from "./components/Sidebar";
import { isLoggedIn, removeToken } from "./utils/auth";

function App() {
  const [loggedIn, setLoggedIn] = useState(isLoggedIn());
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const sidebarRef = useRef(null);
  const navigate = useNavigate();

  const handleLogout = () => {
    removeToken();
    setLoggedIn(false);
    navigate("/login");
  };

  const handleUser = () => {
    navigate("/change-password");
  }

  useEffect(() => {
    function handleClickOutside(event) {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setSidebarOpen(false);
      }
    }
    if (sidebarOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [sidebarOpen]);

  const header = () => {
    return (
      <div className="header">
        <div className="backoffice-logo">
          <img src="/images/logo1.png" alt="VIP Radio Logo"></img>
          <a href="https://backoffice.vip-radio.online/">Vip-Radio.Online</a>
        </div>
        {loggedIn && (
          <>
            <button className="sidebar-toggle" onClick={() => setSidebarOpen(!sidebarOpen)}>
              ☰
            </button>
            <div className="header-btn">
              <button className="user-btn" onClick={handleUser}><i className="fas fa-user"></i></button>
              <button className="logout-btn" onClick={handleLogout}>Logout</button>
            </div>

          </>
        )}
      </div>
    );
  };

  const body = () => {
    return (
      <div className="body">
        {loggedIn && (
          <>
            <div ref={sidebarRef}>
              <Sidebar className={sidebarOpen ? "sidebar open" : "sidebar"} />
            </div>
            {sidebarOpen && <div className="overlay"></div>}
          </>

        )}
        <div className="content">
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/unauthrized" element={<Unauthorized />} />
            <Route path="/404" element={<Page404 />} />
            <Route path="/users/all" element={<AccessControlRoute><UsersAll /></AccessControlRoute>} />
            <Route path="/users/create" element={<AccessControlRoute><UsersCreate /></AccessControlRoute>} />
            <Route path="/change-password" element={<AccessControlRoute><ChangePassword /></AccessControlRoute>} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/playlists" element={<AccessControlRoute><Playlists /></AccessControlRoute>} />
            <Route path="/playlist/settings" element={<AccessControlRoute><PlaylistsSettings /></AccessControlRoute>} />
            <Route path="/tasks" element={<AccessControlRoute><Tasks /></AccessControlRoute>} />
            <Route path="/tasks/create" element={<AccessControlRoute><CreateTask /></AccessControlRoute>} />
            <Route path="/tasks/edit/:id" element={<AccessControlRoute><EditTask /></AccessControlRoute>} />
            <Route path="/whitelist" element={<AccessControlRoute><WhitelistList /></AccessControlRoute>} />
            <Route path="/whitelist/create" element={<AccessControlRoute><WhitelistCreate /></AccessControlRoute>} />
            <Route path="/whitelist/edit/:id" element={<AccessControlRoute><WhitelistEdit /></AccessControlRoute>} />
            <Route path="/dashboard" element={<AccessControlRoute><Dashboard /></AccessControlRoute>} />
            <Route path="*" element={<AccessControlRoute><Navigate to="/users/all" /></AccessControlRoute>} />
          </Routes>
        </div>
      </div>
    );
  };

  const footer = () => {
    return (
      <div className="footer">Backoffice.Vip-Radio.Online © 2025</div>
    );
  };

  return (
    <AudioProvider>
      <div className="app">
        {header()}
        {body()}
        {footer()}
      </div>
    </AudioProvider>

  );
}

export default App;
